import { ActionWithPayload } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";

import { GAME_SESSION_ACTION_TYPE } from "./game-session.action";
import { GameSessionState } from "./game-session.model";

const INITIAL_STATE: GameSessionState = {
	activeGameSessionId: undefined,
};

export function gameSessionReducer(state = INITIAL_STATE, action: ActionWithPayload): GameSessionState {
	switch (action.type) {
		case GAME_SESSION_ACTION_TYPE.setActiveGameSession: {
			return updateState(state, {
				activeGameSessionId: action.payload,
			});
		}

		case GAME_SESSION_ACTION_TYPE.closeGameSessionSuccess: {
			return updateState(state, {
				activeGameSessionId: undefined,
			});
		}

		default:
			return state;
	}
}
